var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarningVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0.959961C8.07188 0.959961 0 9.03184 0 18.96C0 28.8881 8.07188 36.96 18 36.96C27.9281 36.96 36 28.8881 36 18.96C36 9.03184 27.9281 0.959961 18 0.959961Z",
    fill: "#4BAE4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5336 27.193C12.2344 24.8938 9.94922 22.5734 7.64297 20.2742C7.38984 20.0211 7.38984 19.5992 7.64297 19.3461L10.2937 16.6953C10.5469 16.4422 10.9688 16.4422 11.2219 16.6953L15.0117 20.4852L24.757 10.7328C25.0172 10.4797 25.432 10.4797 25.6922 10.7328L28.35 13.3906C28.6102 13.6508 28.6102 14.0656 28.35 14.3188L15.4617 27.193C15.2086 27.4531 14.7937 27.4531 14.5336 27.193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningVerified);
export default __webpack_public_path__ + "static/media/Earning-Verified.d2b0627a33fc01fb5f26b3cdd22739cb.svg";
export { ForwardRef as ReactComponent };